import { render } from "./HelloWorld.vue?vue&type=template&id=33d6fbd0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=33d6fbd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33d6fbd0"

export default script